/* Copyright 2023 (Unpublished) Verto Inc. */

/**
 * Wrapper around localStorage and sessionStorage.
 * Implemented as a hack around a bug in the angular-oidc library
 * where internal code was not using the consumer provided storage object
 * (we would provide localStorage but internally) the library would use sessionStorage in some
 * critical places.
 */
export class SharedWebStorage implements Storage {
  [name: string]: any;

  get length(): number {
    return localStorage.length;
  }

  clear(): void {
    localStorage.clear();
    sessionStorage.clear();
  }
  getItem(key: string): string {
    return localStorage.getItem(key) ?? sessionStorage.getItem(key);
  }

  key(index: number): string {
    return localStorage.key(index) ?? sessionStorage.key(index);
  }

  removeItem(key: string): void {
    if (this[key]) {
      delete this[key];
    }

    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  setItem(key: string, value: string): void {
    this[key] = value;
    localStorage.setItem(key, value);
    sessionStorage.setItem(key, value);
  }
}
